module.exports = __webpack_public_path__ + "img/marker-icon.2b3e1fa.png";